var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"mt-4",attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.loading,"item-key":"id"},scopedSlots:_vm._u([{key:"item.demoUser",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.demoUserName(item)))]}},{key:"item.userType",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.demoUserType(item)))]}},{key:"item.school",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.school || '—'))]}},{key:"item.grade",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.grade || '—'))]}},{key:"item.country",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.country || '—'))]}},{key:"item.startingDate",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.formatCalendarDate(item.startingDate)))]}},{key:"item.finishDate",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.formatCalendarDate(item.finishDate)))]}},{key:"item.lastLoginAt",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.lastLoginAt ? _vm.formatDate(item.lastLoginAt) : '—'))]}},{key:"item.link",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"icon":"","small":"","title":_vm.$t('demos.copy_link')},on:{"click":function($event){return _vm.copy(item.activationCode)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-content-copy")])],1)]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"text":"","small":"","color":"red"},on:{"click":function($event){return _vm.$emit('revoke', item)}}},[_vm._v(_vm._s(_vm.$t('demos.revoke')))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }